import { useModeAwareQuery } from "./useModeAwareQuery";
import { useApi } from "./useApi";

interface CompanySummary {
  totalCompanies: number;
  activeIntegrations: number;
  activeUsers: number;
  documentTemplates: number;
}

const mockSummary: CompanySummary = {
  totalCompanies: 42,
  activeIntegrations: 8,
  activeUsers: 156,
  documentTemplates: 15,
};

/**
 * Hook to fetch company summary counts for the Settings-Company page metric cards.
 * Respects demo/live mode - uses mock data in demo mode, API in live mode.
 */
export function useCompanySummary() {
  const { apiGet } = useApi();

  return useModeAwareQuery<CompanySummary, Error>(
    ["company-summary"],
    async ({ signal }) => {
      return apiGet<CompanySummary>("/api/v1/company/summary", undefined, signal);
    },
    mockSummary,
    {
      staleTime: 0,
      refetchOnMount: 'always',
    }
  );
}
